import { can } from "modules/settings/accessRoles";
import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import { setSnackbar } from "../../../modules/snackbar/api/snackbar";
import moment from 'moment';
import {
    Alert,
    Box,
    Grid,
    Divider as MuiDivider,
    TextField as MuiTextField,
    Button as MuiButton,
    Card as MuiCard,
    CardContent,
    CircularProgress as MuiCircularProgress,
    Dialog,
    DialogContent,
    DialogActions,
    DialogContentText,
    DialogTitle,
    Typography,
    Tooltip
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import VirtualizedAutocompleteListbox from "../../../components/VirtualizedAutocompleteListbox";
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { spacing } from "@mui/system";
import { EditableTable, newDropDownField } from "../../../components/EditableTable";

import { CalculateSelectedPropertyTotalCommonsCharge, buildRiders } from "../../../setup/helpers";
// Redux Components
import PropTypes from "prop-types";
import { connect , useDispatch} from "react-redux";
import { updateLocalPropertyRiderRates, updateRiderRate, deleteRiderRate, createRiderRate, syncRiderRatesBetweenProperties, syncRiderRatesForAllProperties, getPropRiderRatesByPropByUuid, getResolvedRiderRatesByPropertyUuid } from "../api/actions";
import { makeStyles } from '@mui/styles';
import Slide from '@mui/material/Slide';

const Divider = styled(MuiDivider)(spacing);
const Button = styled(MuiButton)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);
const Card = styled(MuiCard)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Table(props) {
    const [riderRatesFormOpen, setRiderRatesFormOpen] = React.useState(false);
    const [riderRatesPropSyncFormOpen, setRiderRatesPropSyncFormOpen] = React.useState(false);
    const [testRiderRatesFormOpen, setTestRiderRatesFormOpen] = React.useState(false);
    const [testRiderRatesFormOpenRefreshFire, setTestRiderRatesFormOpenRefreshFire] = React.useState(false);
    const [targetProperty, setTargetProperty] = React.useState("");
    const [testKwhInput, setTestKwhInput] = React.useState(
        () => props.properties.currentRiderRateTestKwhCharge ?? 1
    );
    const [riderRateTestProduct, setRiderRateTestProduct] = React.useState([]);
    const [riderRateTestProductSummary, setRiderRateTestProductSummary] = React.useState(null);
    const [riderRatesDialogAlertOpen, setriderRatesDialogAlertOpen] = React.useState(false);
    
    const canAddOrUpdate = can(props.user.details, "billingRates");
    const dispatch = useDispatch();

    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1
        },
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        loadingIcon: {
            position: 'relative',
        },
        typography: {
            textAlign: 'center'
        },
        rightSideHeaderSubMenuToolBar: {
            display: "flex",
            alignItems: 'flex-end',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            margin: "0px",
            padding: "0px",
        },
        subMenuToolBarIcon: {
            width: "25px",
            height: "25px",
        },
    }));
    const classes = useStyles();

    // Table Stuff:
    // Preview Table
    const readOnly_fieldTitles = ["Name", "Type", "Basis"];
    const readOnly_fieldTypes = ["label", "label", "label"];
    const readOnly_fieldNames = ["riderName", "riderType", "rateBasis"];

    // Editable Table
    const editable_fieldTitles = ["Name", "Type", "Min/Max Kwh", "Rate Basis", "Summer/Winter Rate", "Rate Type", "Start/End"];
    const editable_fieldTypes = ["text", "dropDown", ["number", "number"], "dropDown", ["number", "number"], "dropDown", ["dateField", "dateField"]];
    const editable_fieldNames = ["riderName", "riderType", ["minKwh", "maxKwh"], "rateBasis", ["rateSummer", "rateWinter"], "rateType", ["startDate", "endDate"]];
    const editable_ResourceFields = [
        newDropDownField("riderType", [{ "x": "Distribution" }, { "x": "Generation" }, { "x": "Transmission" },], "x", "x"),
        newDropDownField("rateBasis", [{ "x": "kWh" }, { "x": "Flat" }, { "x": "Base" },], "x", "x"),
        newDropDownField("rateType", [{ "x": "$" }, { "x": "%" }], "x", "x"),
    ];

    const updateLocalItemsValues = (items) => {
        props.updateLocalPropertyRiderRates(items);
    }

    const createLineItemData = (riderName, riderType, minKwh, maxKwh, rateBasis, rateSummer, rateWinter, rateType, startDate, endDate) => {
        return { riderName, riderType, minKwh, maxKwh, rateBasis, rateSummer, rateWinter, rateType, startDate, endDate };
    }

    const createBlankLineItem = () => {
        return createLineItemData("", "", 0, 0, "", 0, 0, "", "", "");
    }

    const addBlankItemToArray = () => {
        const rr = props.properties.propertyRiderRates;
        props.updateLocalPropertyRiderRates({
            ...rr,
            items: [...(rr.items || []), createBlankLineItem()],
        });
    }



    // To be used to save over the api in the database
    const saveAllLineItems = (riderRates) => {
        props.updateLocalPropertyRiderRates(riderRates);
        riderRates.toUpdate.map(targetUuid => {
            let targetItemIndex = riderRates.items.findIndex(x => x.uuid === targetUuid);
            if (targetItemIndex != -1) {
                props.updateRiderRate(riderRates.items[targetItemIndex]);
            }
        });
        riderRates.toDelete.map(targetUuid => {
            props.deleteRiderRate(targetUuid, props.properties.data.property.uuid);
        });
        var ridersToCreate = [];
        var existingRiders = [];
        for (var x = 0; x < riderRates.items.length; x++) {
            if (!riderRates.items[x].id) {
                ridersToCreate.push(riderRates.items[x]);
            }
            else {
                existingRiders.push(riderRates.items[x]);
            }
        }
        if (ridersToCreate.length > 0) {
            props.createRiderRate(ridersToCreate, props.properties.data.property.uuid);
        }
        props.updateLocalPropertyRiderRates({
            items: existingRiders,
            toUpdate: [],
            toDelete: [],
        });
    }


    const handleTestRiderRatesFormClickOpen = () => {
        setTestKwhInput(props.properties.currentRiderRateTestKwhCharge ?? 1);
        setTestRiderRatesFormOpen(true);
    };
    const handleTestRiderRatesFormClickClose = () => {
        setTestRiderRatesFormOpen(false);
        setTestRiderRatesFormOpenRefreshFire(false);
    };

    const handleRiderRatesPropSyncFormClickOpen = () => {
        setRiderRatesPropSyncFormOpen(true);
    };

    const handleRiderRatesPropSyncFormClose = () => {
        setRiderRatesPropSyncFormOpen(false);
        setTargetProperty("");
    };

    const handleRiderRatesFormClickOpen = () => {
        setRiderRatesFormOpen(true);
    };

    const handleRiderRatesFormClose = () => {
        setRiderRatesFormOpen(false);
    };
    const onSyncAllRiderRatesComplete = async () => {
        let syncAllProps = await props.syncRiderRatesForAllProperties(props.properties.data.property.uuid);
        if(syncAllProps.data?.success == "true"){
        dispatch(setSnackbar(true , "success", "Sync All Property Rider Rates Successful"));
        }else{
        dispatch(setSnackbar(true , "error", "Sync All Property Rider Rates Error"));
        }
         handleRiderRatesDialogAlertClose();
    };
    const onRiderRatesTestKwhChange = (event) => {
        setTestKwhInput(Number(event.target.value));
    };

    const handleRefreshTestClick = () => {
        CalculateTestRiderRate();
    };
    const handleRiderRatesDialogAlertOpen = () => {
        setriderRatesDialogAlertOpen(true);
    };
    
    const handleRiderRatesDialogAlertClose = () => {
        setriderRatesDialogAlertOpen(false);
    };


    const CalculateTestRiderRate = React.useCallback(() => {
        const currentTestKwhValue = testKwhInput || 1;
        if (
            !props.properties.propertyResidualAmountsToAddIsLoading &&
            !props.properties.propertyAdditionalCommonAreaExpensesIsLoading &&
            !props.properties.isLoading
        ) {
            CalculateSelectedPropertyTotalCommonsCharge(
                props.properties.propertyAdditionalCommonAreaExpenses,
                props.properties.propertyResidualAmountsToAdd,
                props.properties.data.property.totalUnits
            );
        }
        const today = moment().format("MM/DD/YYYY");
        const propertyRiderItems = props.properties.propertyRiderRates?.items || [];
        const resolvedRiders =
            props.properties.propertyResolvedRiderRates?.items?.length
                ? props.properties.propertyResolvedRiderRates.items
                : propertyRiderItems;
        const resolvedBaseCharge = props.properties.propertyResolvedRiderRates?.effectiveBaseCharge;
        const testRiderResult = buildRiders(
            currentTestKwhValue,
            props.propertyUtilities.data.propertyUtility,
            resolvedRiders,
            0,
            today,
            props.properties.data.property.totalUnits,
            currentTestKwhValue,
            resolvedBaseCharge
        );
        setRiderRateTestProductSummary(testRiderResult.bill);
        setRiderRateTestProduct(testRiderResult.riders);
    }, [
        testKwhInput,
        props.properties.propertyResidualAmountsToAddIsLoading,
        props.properties.propertyAdditionalCommonAreaExpensesIsLoading,
        props.properties.isLoading,
        props.properties.propertyAdditionalCommonAreaExpenses,
        props.properties.propertyResidualAmountsToAdd,
        props.properties.data.property.totalUnits,
        props.properties.propertyRiderRates?.items,
        props.properties.propertyResolvedRiderRates,
        props.propertyUtilities.data.propertyUtility,
    ]);

    useEffect(() => {
        const propertyUuid = props.properties.data.property?.uuid;
        if (propertyUuid) {
            props.getResolvedRiderRatesByPropertyUuid(propertyUuid, moment().format("YYYY-MM-DD"));
        }
    }, [props.properties.data.property?.uuid, props.getResolvedRiderRatesByPropertyUuid]);

    useEffect(() => {
        if (testRiderRatesFormOpen && !testRiderRatesFormOpenRefreshFire) {
            props.getPropRiderRatesByPropByUuid(props.properties.data.property.uuid);
            props.getResolvedRiderRatesByPropertyUuid(
                props.properties.data.property.uuid,
                moment().format("YYYY-MM-DD")
            );
            setTestRiderRatesFormOpenRefreshFire(true);
        }
    }, [testRiderRatesFormOpen, testRiderRatesFormOpenRefreshFire, props.properties.data.property.uuid]);

    useEffect(() => {
        if (!testRiderRatesFormOpen) {
            return;
        }
        if (
            props.properties.riderRatesAreLoading ||
            props.properties.propertyResolvedRiderRates?.isLoading ||
            props.properties.propertyAdditionalCommonAreaExpensesIsLoading ||
            props.properties.propertyResidualAmountsToAddIsLoading
        ) {
            return;
        }
        CalculateTestRiderRate();
    }, [
        testRiderRatesFormOpen,
        testKwhInput,
        props.properties.riderRatesAreLoading,
        props.properties.propertyResolvedRiderRates?.isLoading,
        props.properties.propertyAdditionalCommonAreaExpensesIsLoading,
        props.properties.propertyResidualAmountsToAddIsLoading,
        CalculateTestRiderRate,
    ]);

    const customToolbar = useMemo(
        () => (
            <Grid container spacing={4} className={classes.rightSideHeaderSubMenuToolBar}>
                <Grid item>
                    <Tooltip title="Test Rider Rates Outputs">
                        <Button onClick={handleTestRiderRatesFormClickOpen} aria-label="Test rider rate outputs with different kwh usages">
                            <AssignmentTurnedInIcon fontSize="medium" className={classes.subMenuToolBarIcon} />
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Sync Rider Rates With Other Property">
                        <Button hidden={!canAddOrUpdate} onClick={handleRiderRatesPropSyncFormClickOpen} aria-label="Sync Rider Rates With Other Property">
                            <FileCopyIcon fontSize="medium" className={classes.subMenuToolBarIcon} />
                        </Button>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Edit Rider Rates">
                        <Button hidden={!canAddOrUpdate} onClick={handleRiderRatesFormClickOpen} aria-label="Edit Rider Rates">
                            <EditIcon fontSize="medium" className={classes.subMenuToolBarIcon} />
                        </Button>
                    </Tooltip>
                </Grid>
            </Grid>
        ),
        [
            canAddOrUpdate,
            classes.rightSideHeaderSubMenuToolBar,
            classes.subMenuToolBarIcon,
            handleTestRiderRatesFormClickOpen,
            handleRiderRatesPropSyncFormClickOpen,
            handleRiderRatesFormClickOpen,
        ]
    );
    var currentCustomerCharge = 0;
    if (props.propertyUtilities.data.propertyUtility) {
        currentCustomerCharge = props.propertyUtilities.data.propertyUtility.utilCustomerCharge;
    }
    const vendorName = props.propertyUtilities.data.propertyUtility?.vendorName || "vendor";
    const isInheritedLoading = props.properties.propertyResolvedRiderRates?.isLoading;
    const inheritedItems = props.properties.propertyResolvedRiderRates?.vendorRiders || [];
    const hasInheritedRates = inheritedItems.length > 0;
    const inheritedVendorRiders = {
        items: inheritedItems,
        toUpdate: [],
        toDelete: [],
    };
    const hasVendor = Boolean(props.propertyUtilities.data.propertyUtility?.vendorId);
    const rateSelectionHelp =
        "If the vendor has no rates, billing uses these property rates. " +
        "If both exist, vendor rates are the base set; a property rate with the same name, type, and start date replaces that vendor rate, " +
        "and a property rate with a different name/type/start date is added as an extra charge for this property only.";

    const RateHelpIcon = (
        <Tooltip title={rateSelectionHelp} arrow placement="top">
            <InfoOutlinedIcon
                fontSize="small"
                color="action"
                sx={{ ml: 0.5, verticalAlign: "middle", cursor: "help" }}
                aria-label="How rider rates are chosen"
            />
        </Tooltip>
    );

    return (
        <Card mb={6} elevation={3}>
            <CardContent>
                {!hasVendor ? (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        No vendor is assigned to this property. Rider rates are managed only at the property level.
                    </Alert>
                ) : null}
                {hasInheritedRates ? (
                    <EditableTable
                        customToolbar={null}
                        readOnly={true}
                        canSave={false}
                        canAddItems={false}
                        isLoading={isInheritedLoading}
                        tableTitle={`Inherited from ${vendorName} (read-only)`}
                        objectArray={inheritedVendorRiders}
                        fieldTitles={readOnly_fieldTitles}
                        fieldTypes={readOnly_fieldTypes}
                        fieldNames={readOnly_fieldNames}
                    />
                ) : isInheritedLoading ? (
                    <Box sx={{ mb: 1 }}>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                            Inherited from {vendorName} (read-only)
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
                            <CircularProgress size={20} />
                            <Typography variant="body2" color="text.secondary">
                                Loading inherited rider rates…
                            </Typography>
                        </Box>
                    </Box>
                ) : hasVendor ? (
                    <Box sx={{ mb: 1 }}>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                            Inherited from {vendorName} (read-only)
                        </Typography>
                        <Alert severity="info">
                            No rider rates inherited from {vendorName}. Property overrides below are used until vendor rates are uploaded.
                        </Alert>
                    </Box>
                ) : null}
                <Divider my={4} />
                <EditableTable
                    customToolbar={customToolbar}
                    readOnly={true}
                    canSave={false}
                    canAddItems={false}
                    isLoading={props.properties.riderRatesAreLoading}
                    tableTitle={
                        <span>
                            Property Overrides
                            {RateHelpIcon}
                        </span>
                    }
                    objectArray={props.properties.propertyRiderRates}
                    fieldTitles={readOnly_fieldTitles}
                    fieldTypes={readOnly_fieldTypes}
                    fieldNames={readOnly_fieldNames}
                />
            </CardContent>

            {/* Rider Rates Editor Dialog */}
            <Dialog
                open={riderRatesFormOpen}
                TransitionComponent={Transition}
                fullWidth={true}
                maxWidth={"xl"}
                onClose={handleRiderRatesFormClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                {riderRatesFormOpen ? (
                    <DialogContent>
                        <EditableTable
                            hideRowFieldTitles={true}
                            canExport={true}
                            newItemCreationMethod={addBlankItemToArray}
                            isLoading={props.properties.riderRatesAreLoading}
                            tableTitle={"Property Overrides"}
                            objectArray={props.properties.propertyRiderRates}
                            fieldTitles={editable_fieldTitles}
                            fieldTypes={editable_fieldTypes}
                            fieldNames={editable_fieldNames}
                            dropDownFields={editable_ResourceFields}
                            saveCurrentTableData={saveAllLineItems}
                            updateItemsLocalState={updateLocalItemsValues}
                        />
                    </DialogContent>
                ) : null}
            </Dialog>

            {/* Test Rider Rates Dialog  */}
            <Dialog
                open={testRiderRatesFormOpen}
                TransitionComponent={Transition}
                fullWidth={"lg"}
                maxWidth={"lg"}
                onClose={handleTestRiderRatesFormClickClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                {testRiderRatesFormOpen ? (
                <>
                <DialogTitle>
                    Test Rider Rates Output
                </DialogTitle>
                <DialogContent>{props.properties.riderRatesAreLoading || props.properties.propertyAdditionalCommonAreaExpensesIsLoading || props.properties.propertyResidualAmountsToAddIsLoading || riderRateTestProductSummary == null ?
                    <Grid container spacing={0}>
                        <Grid item lg={12} md={12} sm={12}>
                            <Divider className="mb-2 mt-2" my={1} />
                        </Grid>
                        <Grid item lg={6} md={6} sm={6}>
                            <Typography variant="h5" >
                                Loading Property Rider Rates and Common Charges
                            </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6}>
                            <CircularProgress disableShrink className={classes.loadingIcon} />
                        </Grid>
                    </Grid>
                    :
                    <>
                        <Grid container spacing={2} className={classes.rightSideHeaderSubMenuToolBar}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid item lg={12} md={12} sm={12}>
                                    <TextField
                                        id="kwh"
                                        label="KWH"
                                        type="number"
                                        fullWidth
                                        my={2}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={testKwhInput}
                                        onChange={onRiderRatesTestKwhChange}
                                        name="kwh"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12}>
                                <MuiButton fullWidth variant="contained" onClick={handleRefreshTestClick} color="secondary">
                                    Refresh Test
                                </MuiButton>
                            </Grid>
                            {(riderRateTestProductSummary && riderRateTestProductSummary != null) &&
                                <Grid container spacing={1}>
                                    <Grid item lg={12} md={12} sm={12}>
                                        <Divider className="mb-2 mt-2" my={1} />
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12}>
                                        <Grid container spacing={3}>
                                            <Grid item lg={4} md={4} sm={4}>
                                                <Typography variant="h5">
                                                    Total Charge: $ {(riderRateTestProductSummary.totalCharge || 0).toFixed(4)}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Rider Rates + Customer Charge + Energy Charge
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={4} md={4} sm={4}>
                                                <Typography variant="h5">
                                                    Cost / KWH: $ {((riderRateTestProductSummary.totalCharge || 0) / (testKwhInput || 1)).toFixed(4)}
                                                </Typography>
                                                <Typography variant="body2">
                                                    (Total Charge) / kWh
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={4} md={4} sm={4}>
                                                <Typography variant="h5">
                                                    Complete Bill: $ {((riderRateTestProductSummary.totalCharge || 0) + (riderRateTestProductSummary.commonAreaTotal || 0)).toFixed(4)}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Rider Rates + Customer Charge + Common Charge
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12}>
                                        <Divider className="mb-2 mt-2" my={1} />
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Riders Total: $ {(riderRateTestProductSummary.utilRidersTotal || 0).toFixed(4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Energy Total: $ {(riderRateTestProductSummary.utilEnergyCharge || 0).toFixed(4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Common Charge Total: $  {(riderRateTestProductSummary.commonAreaTotal || 0).toFixed(4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Customer Charge: $ {currentCustomerCharge}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Generation Total: $ {(riderRateTestProductSummary.utilGenerationTotal || 0).toFixed(4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Transmission Total: $ {(riderRateTestProductSummary.utilTransmissionTotal || 0).toFixed(4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h6" >
                                            Distribution Total: $ {(riderRateTestProductSummary.utilDistributionTotal || 0).toFixed(4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12}>
                                        <Divider className="mb-2 mt-2" my={1} />
                                    </Grid>
                                </Grid>
                            }
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Grid container>
                                    <Grid item lg={4} md={4} sm={4}>
                                        <Typography variant="h5" >
                                            Rider Name
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={2} md={2} sm={2}>
                                        <Typography variant="h5" >
                                            Type
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={2} md={2} sm={2}>
                                        <Typography variant="h5" >
                                            Value Type
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={2} md={2} sm={2}>
                                        <Typography variant="h5" >
                                            Rider Rate
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={2} md={2} sm={2}>
                                        <Typography variant="h5" >
                                            Rider Cost On Bill
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Divider className="mb-2 mt-2" my={2} />
                                {riderRateTestProduct.map((rider, index) => {
                                    return (<React.Fragment key={index}>
                                        <Grid container>
                                            <Grid item lg={4} md={4} sm={4}>
                                                <Typography variant="body2" >
                                                    {rider.riderName}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={2} md={2} sm={2}>
                                                <Typography variant="body2" >
                                                    {rider.riderType}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={2} md={2} sm={2}>
                                                <Typography variant="body2" >
                                                    {rider.rateType}, {rider.rateBasis}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={2} md={2} sm={2}>
                                                <Typography variant="body2" >
                                                    {rider.effectiveRate}
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={2} md={2} sm={2}>
                                                <Typography variant="body2" >
                                                    $ {rider.riderAmount}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider className="mb-2 mt-2" my={1} />
                                    </React.Fragment>)
                                })
                                }
                            </Grid>
                        </Grid>
                        <Divider className="mb-2 mt-2" my={4} />
                    </>
                }
                </DialogContent>
                </>
                ) : null}
            </Dialog>
            {/* Property Sync Dialog */}
            <Dialog
                open={riderRatesPropSyncFormOpen}
                TransitionComponent={Transition}
                fullWidth={"md"}
                maxWidth={"md"}
                keepMounted
                onClose={handleRiderRatesPropSyncFormClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                {riderRatesPropSyncFormOpen ? (
                <>
                <DialogTitle>
                    Sync Properties Rider Rates with Current Property
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={4} className={classes.rightSideHeaderSubMenuToolBar}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Autocomplete
                                options={(props.apl && props.apl.data && props.apl.data.propertyPreviews) || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={
                                    ((props.apl && props.apl.data && props.apl.data.propertyPreviews) || []).find(
                                        (item) => item.uuid === targetProperty
                                    ) || null
                                }
                                onChange={(e, newValue) => setTargetProperty(newValue?.uuid || "")}
                                loading={props.apl.isLoading}
                                ListboxComponent={VirtualizedAutocompleteListbox}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Target Property"
                                        my={2}
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {props.apl.isLoading ? (
                                                        <CircularProgress color="inherit" size={15} />
                                                    ) : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                            <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
                                Type to filter; long lists scroll with virtualization (all matches stay available).
                            </Typography>
                            <Divider className="mb-2 mt-2" my={4} />
                                <Button variant="contained" color="secondary" onClick={handleRiderRatesDialogAlertOpen}>Override All Rider Rates</Button>
                                <Dialog
                                    open={riderRatesDialogAlertOpen}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">

                                    </DialogTitle>
                                    <DialogContent>
                                    <DialogContentText color="black">
                                        Are you sure you want to override all rider rates?
                                    </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={handleRiderRatesDialogAlertClose}>Close</Button>
                                    <Button  variant="contained" color="secondary"  onClick={() => {
                                            onSyncAllRiderRatesComplete();
                                     
                                    }} autoFocus>
                                        Yes
                                    </Button>
                                    </DialogActions>
                                </Dialog>
                        </Grid>
                        {targetProperty != "" &&
                            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.rightSideHeaderSubMenuToolBar}>
                                <Button variant="contained" color="secondary" onClick={() => {
                                    props.syncRiderRatesBetweenProperties(props.properties.data.property.uuid, targetProperty);
                                    handleRiderRatesPropSyncFormClose();
                                }} my={0}>Override Target Property's Rider Rates</Button>
                                
                            </Grid>}
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                        </Grid>
                    </Grid>
                    <Divider className="mb-2 mt-2" my={4} />
                </DialogContent>
                </>
                ) : null}
            </Dialog>
        </Card>
    );
}
// Component units
Table.propTypes = {
    // Store objects:
    user: PropTypes.object.isRequired,
    apl: PropTypes.object.isRequired,
    properties: PropTypes.object.isRequired,
    propertyUtilities: PropTypes.object.isRequired,
    updateLocalPropertyRiderRates: PropTypes.func.isRequired,
    updateRiderRate: PropTypes.func.isRequired,
    deleteRiderRate: PropTypes.func.isRequired,
    createRiderRate: PropTypes.func.isRequired,
    syncRiderRatesBetweenProperties: PropTypes.func.isRequired,
    syncRiderRatesForAllProperties: PropTypes.func.isRequired,
    getPropRiderRatesByPropByUuid: PropTypes.func.isRequired,
    getResolvedRiderRatesByPropertyUuid: PropTypes.func.isRequired,
};

// Component State
function State(state) {
    return {
        user: state.user,
        apl: state.apl,
        properties: state.properties,
        propertyUtilities: state.propertyUtilities
    };
}
export default connect(State, { syncRiderRatesForAllProperties,syncRiderRatesBetweenProperties, updateLocalPropertyRiderRates, updateRiderRate, deleteRiderRate, createRiderRate, getPropRiderRatesByPropByUuid, getResolvedRiderRatesByPropertyUuid })(Table);
